var getBuiltIn = require(28);

module.exports = getBuiltIn('navigator', 'userAgent') || '';
